import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/introduction',
    name: 'introduction',
    component: () => import(/* webpackChunkName: "about" */ '../views/aboutUs.vue')
  },
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "about" */ '../views/xinqiyi-home.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
